import React from "react";

const LABEL_H = 20;

export interface SectorBounds {
  sectorId: string;
  sectorName: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

const SectorOverlay: React.FC<{
  sectorBounds: SectorBounds[];
  isDark: boolean;
  width: number;
  height: number;
}> = ({ sectorBounds, isDark, width, height }) => {
  if (!sectorBounds.length) return null;

  return (
    <svg
      width={width}
      height={height}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        pointerEvents: "none",
        overflow: "visible",
      }}
    >
      {sectorBounds.map((sb) => {
        if (sb.width < 24 || sb.height < 16) return null;

        const barH = Math.min(LABEL_H, sb.height * 0.2);
        const fontSize = Math.min(Math.max(barH * 0.6, 9), 13);
        const maxChars = Math.floor(sb.width / (fontSize * 0.58));
        const label =
          sb.sectorName.length > maxChars
            ? sb.sectorName.slice(0, maxChars - 1) + "…"
            : sb.sectorName;

        const textWidth = label.length * fontSize * 0.6;
        const paddingX = 12;
        const bgWidth = Math.min(textWidth + paddingX, sb.width - 6);

        return (
          <g key={sb.sectorId}>
            {/* Outer border for the sector group */}
            <rect
              x={sb.x + 1}
              y={sb.y + 1}
              width={sb.width - 2}
              height={sb.height - 2}
              fill="none"
              stroke={isDark ? "#334155" : "#94a3b8"}
              strokeWidth={0.5}
              rx={4}
            />
            {/* Label bar background */}
            <rect
              x={sb.x + 1}
              y={sb.y + 1}
              width={bgWidth}
              height={barH}
              fill={isDark ? "rgba(15,22,35,0.82)" : "rgba(226,232,240,0.90)"}
              rx={4}
            />
            {/* Label text */}
            {sb.width > 36 && (
              <text
                x={sb.x + 1 + paddingX / 2}
                y={sb.y + 1 + barH / 2}
                dominantBaseline="middle"
                fill={isDark ? "#cbd5e1" : "#334155"}
                fontSize={fontSize}
                fontWeight={700}
                fontFamily="'Syne', sans-serif"
              >
                {label}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
};

export default SectorOverlay;
